// iOS-style toggle switch — ports the .toggle-switch / .toggle-slider markup
// from the original styles.css (44×24 track, 20px thumb, blue-light when on).
import type { ChangeEvent } from 'react'
import styles from './Toggle.module.css'

interface ToggleProps {
  checked: boolean
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
}

export default function Toggle({ checked, onChange, disabled }: ToggleProps) {
  return (
    <label className={styles.toggle}>
      <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
      <span className={styles.slider} />
    </label>
  )
}
